/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SponsorDto } from '../../models/sponsor-dto';
import { UpdateSponsorDto } from '../../models/update-sponsor-dto';

export interface SponsorControllerUpdateV1$Params {
  id: string;
      body: UpdateSponsorDto
}

export function sponsorControllerUpdateV1(http: HttpClient, rootUrl: string, params: SponsorControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<SponsorDto>> {
  const rb = new RequestBuilder(rootUrl, sponsorControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SponsorDto>;
    })
  );
}

sponsorControllerUpdateV1.PATH = '/api/v1/sponsor/{id}';
